<template>
  <ValidationProvider :name="i18n ? $t(i18n).toLowerCase() : ''" :rules="rules ? rules : ''">
    <component
      :is="type"
      :id="id"
      slot-scope="{ errors }"
      v-model="model"
      v-bind="props"
      v-on="events"
      :disabled="readOnly"
      :error-messages="errors"
      :label="label"
      :placeholder="placeHolder ? placeHolder : ''"
      :type="inputType ? inputType : ''"
    >
      <template v-for="slot in Object.keys($slots)" v-slot:[slot]>
        <slot :name="slot"></slot>
      </template>
    </component>
  </ValidationProvider>
</template>

<script>
import { VTextarea, VTextField } from "vuetify/lib"

export default {
  name: "FormField",
  components: { VTextField, VTextarea },
  props: {
    value: { required: true },
    id: { required: false },
    props: { type: Object, default: () => ({}) },
    events: { type: Object, default: () => ({}) },
    type: { type: String, default: "VTextField" },
    inputType: { type: String, default: null },
    inputStyle: { type: String, default: null },
    placeHolder: { type: String, default: null },
    i18n: { type: String, default: null },
    rules: { type: String, default: null },
    readOnly: { type: Boolean, default: false },
    notRequired: { type: Boolean, default: false },
  },
  watch: {
    value(newValue) {
      this.model = newValue
    },
    model(newValue) {
      this.$emit("input", newValue)
    },
  },
  data: () => ({
    model: null,
  }),
  computed: {
    label() {
      let label = ""
      if (this.i18n) {
        label = this.$t(this.i18n)
      }
      if (this.readOnly) {
        label = label + " (" + this.$t("common.readonly") + ")"
      }
      if (this.notRequired) {
        label = label + " (" + this.$t("common.not_required") + ")"
      }
      return label
    },
  },
}
</script>
